module.exports = __webpack_public_path__ + "img/dongji_ps_16.b04c166f.jpg";